export enum BrowserType {
    "micromessenger" = "wechat",
    "ucbrowser" = "uc",
    "baiduboxapp" = "baidu",
    "qqbrowser" = "qq",
    "firefox" = "firefox",
    "opr" = "opera",
    "chrome" = "chrome",
    "safari" = "safari",
    "ie" = "ie",
    "edg" = "edg"
}